import { Event } from './event';

export class DataProcessingAgreementConfirmedEvent extends Event<void> {}
